import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ViewIntersectIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="viewIntersect" ref={ref} {...props}>
    <path d="M19,6.51h-.46V6.05A3.76,3.76,0,0,0,14.79,2.3H5A3.76,3.76,0,0,0,1.25,6.05v7.69A3.76,3.76,0,0,0,5,17.49h.46V18A3.76,3.76,0,0,0,9.21,21.7H19A3.76,3.76,0,0,0,22.75,18V10.26A3.76,3.76,0,0,0,19,6.51ZM5,16a2.25,2.25,0,0,1-2.25-2.25V6.05A2.25,2.25,0,0,1,5,3.8h9.79A2.25,2.25,0,0,1,17,6.05v.46H9.21a3.76,3.76,0,0,0-3.75,3.75V16Zm16.25,2A2.25,2.25,0,0,1,19,20.2H9.21A2.25,2.25,0,0,1,7,18v-.46h7.83a3.76,3.76,0,0,0,3.75-3.75V8H19a2.25,2.25,0,0,1,2.25,2.25Z" />
  </Icon>
)) as IconWithRender;

ViewIntersectIcon.displayName = 'ViewIntersectIcon';
ViewIntersectIcon.renderIcon = (props) => <ViewIntersectIcon {...props} />;
export default ViewIntersectIcon;
